export default __webpack_public_path__ + "static/media/14ca86392d9a611e2657523416c71232.svg";